import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const AuthGuard: CanActivateFn = (_route, _state) => {
	const authService = inject(AuthService);
	const router = inject(Router);
	if (authService.isAuthenticated()) {
		return true;
	} else {
		localStorage.clear();
		void router.navigate(['/login']);
		return false;
	}
};
